<ng-template #departuresBlock>
    <div
        class="bg-white px-4"
        *ngFor="let departureGroup of showingDepartureGroups; trackBy: trackByDepartureGroup; let lastGroup = last"
        [ngClass]="{ 'shadow-md': !isStopShort && isGroupedRoutes }"
        [class.mb-4]="!lastGroup && isGroupedRoutes"
        [class.mb-0]="lastGroup">
        <ng-container *ngIf="isGroupedRoutes && departureGroup.date">
            <div
                class="border-b border-solid py-3 text-xs font-bold leading-4 text-grey-dark last:border-none dark:border-contrast-yellow dark:text-contrast-yellow">
                {{ departureGroup.date | uppercase }}
            </div>
        </ng-container>
        <ul class="word-break-break-word" role="list">
            <li
                class="border-b border-solid py-3 last:border-none dark:border-contrast-yellow"
                *ngFor="
                    let departure of departureGroup.departures;
                    trackBy: trackByTripId;
                    let i = index;
                    let total = count
                "
                [attr.aria-posinset]="i + 1"
                [attr.aria-setsize]="total">
                <button class="w-full" (click)="emitTripClick(departure)" role="button">
                    <ng-container [ngTemplateOutlet]="tripDepartureV1" [ngTemplateOutletContext]="{ departure }">
                    </ng-container>
                </button>
            </li>
        </ul>
    </div>
</ng-template>

<ng-container *ngIf="isLoadingDepartures === true; else departuresBlock">
    <div class="bg-white dark:bg-contrast-black">
        <div class="flex px-2 pt-2">
            <ridango-ui-skeleton-loader class="w-full" height="2.75rem" count="10"></ridango-ui-skeleton-loader>
        </div>
    </div>
</ng-container>

<ng-template #tripDepartureV1 let-departure="departure">
    <rwidget-trip-departure
        [time]="departure.time"
        [route]="departure.route"
        (click)="emitTripClick(departure)"></rwidget-trip-departure>
</ng-template>

<div class="bg-white p-6 text-center" *ngIf="!departures.length && stop">
    {{ 'EXPLORE_NO_TIME_STOPS' | translate }}
</div>

<ng-container *ngIf="showLoadMoreButton()">
    <div class="flex-column flex bg-white px-3 shadow-md">
        <ion-button
            class="pn-app-light:text-primary pn-light:text-primary m-0 cursor-pointer border-t border-solid py-2 text-center text-base font-semibold text-secondary dark:border-contrast-yellow dark:text-contrast-yellow"
            [class.normal-case]="env.REMOVE_UPPERCASE"
            [attr.aria-label]="'SHOW_MORE_ELLIPSIS' | translate"
            (click)="loadMoreDepartures()"
            fill="clear"
            >{{ 'SHOW_MORE_ELLIPSIS' | translate }}
        </ion-button>
    </div>

    <div class="flex-column flex dark:bg-contrast-black">
        <ion-button
            class="pn-app-light:text-primary pn-light:text-primary сursor-pointer mt-4 h-14 whitespace-normal text-center font-semibold text-secondary dark:text-contrast-yellow"
            [class.normal-case]="env.REMOVE_UPPERCASE"
            [attr.aria-label]="'SHOW_ALL_ELLIPSIS' | translate"
            (click)="loadAllDepartures()"
            fill="clear"
            >{{ 'SHOW_ALL_ELLIPSIS' | translate }}
        </ion-button>
    </div>
</ng-container>
